import React from 'react';
import ApexNavbar from '../components/apex/ApexNavbar';
import ApexFooter from '../components/apex/ApexFooter';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <ApexNavbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 tracking-tight" data-testid="privacy-heading">
            Privacy Policy
          </h1>
          <p className="text-[#71717A] mb-10">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="space-y-10 text-[#A1A1AA] leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Information We Collect</h2>
              <p className="mb-3">We collect information you provide directly, such as when you fill out a contact form, request a discovery audit, or communicate with us. This may include:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Name, email address, and phone number</li>
                <li>Gym name and location</li>
                <li>Business details and service preferences</li>
                <li>Any other information you choose to provide</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. How We Use Your Information</h2>
              <p className="mb-3">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Respond to your inquiries and provide requested services</li>
                <li>Send you relevant communications about our coaching services</li>
                <li>Improve our website, products, and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Information Sharing</h2>
              <p>We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers who assist us in operating our website and conducting our business, provided they agree to keep your information confidential.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Data Security</h2>
              <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Cookies</h2>
              <p>Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings, though this may affect certain functionality of the website.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Your Rights</h2>
              <p className="mb-3">You have the right to:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Access the personal data we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt out of marketing communications at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:kyran@apexfitsalescoaching.com" className="text-[#22C55E] hover:underline">kyran@apexfitsalescoaching.com</a>.</p>
            </section>
          </div>
        </div>
      </main>
      <ApexFooter />
    </div>
  );
};

export default PrivacyPolicy;
